export default "__VITE_ASSET__BZqHOFII__"